<div
  class="relative h-full w-full min-h-[520px] overflow-hidden"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div class="relative h-full w-full">
    <div
      *ngFor="let slide of slides; let i = index"
      class="absolute inset-0 flex flex-col justify-between pb-12 opacity-0 transition-opacity duration-500 ease-in-out pointer-events-none"
      [class.opacity-100]="i === currentIndex"
      [class.pointer-events-auto]="i === currentIndex"
      [class.z-10]="i === currentIndex"
      [attr.data-slide]="slide.id"
    >
      <div
        class="flex min-h-0 flex-1 items-center justify-center px-8 pb-4 pt-8"
      >
        <!-- Job Matcher -->
        <div
          *ngIf="slide.visual === 'matcher'"
          class="w-full max-w-[370px]"
          [class.login-carousel-animate-slide-in]="i === currentIndex"
        >
          <div class="relative flex h-full w-full items-center justify-center">
            <div
              class="relative w-full max-w-[400px]"
              [class.login-carousel-animate-card-float]="i === currentIndex"
            >
              <div
                class="pointer-events-none absolute bottom-[-12px] left-1/2 z-0 h-full w-[92%] -translate-x-1/2 rounded-2xl bg-[rgb(230_226_226/60%)]"
              ></div>
              <div
                class="pointer-events-none absolute bottom-[-6px] left-1/2 z-0 h-full w-[96%] -translate-x-1/2 rounded-2xl bg-[rgb(230_226_226/60%)]"
              ></div>
              <div
                class="relative z-[1] rounded-2xl border-[1.5px] border-[#e4e4e4] bg-white p-[1.125rem] shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
              >
                <div class="mb-3 flex items-center justify-between">
                  <div class="flex items-center gap-2">
                    <div
                      class="flex h-[2.125rem] w-[2.125rem] items-center justify-center rounded-lg border-[1.5px] border-[#e4e4e4] bg-white"
                    >
                      <svg
                        class="h-[1.125rem] w-[1.125rem]"
                        viewBox="0 0 100 100"
                        fill="none"
                      >
                        <rect
                          x="10"
                          y="10"
                          width="80"
                          height="80"
                          rx="8"
                          stroke="#111"
                          stroke-width="5"
                        />
                        <path
                          d="M35 75L50 25L65 75"
                          stroke="#111"
                          stroke-width="6"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M62 25L75 75"
                          stroke="#111"
                          stroke-width="6"
                          stroke-linecap="round"
                        />
                      </svg>
                    </div>
                    <span
                      class="text-[13px] font-medium text-[#444] underline decoration-[#ccc] decoration-1 underline-offset-[3px]"
                    >
                      Anthropic
                    </span>
                  </div>
                  <span
                    class="rounded-full bg-[#e6f9ed] px-[9px] py-[3px] text-[10.5px] font-semibold text-[#22863a]"
                    [class.login-carousel-animate-badge-pulse]="i === currentIndex"
                  >
                    81% Match
                  </span>
                </div>
                <div class="mb-[3px] text-base font-bold text-[#111]">
                  Senior Product Designer
                </div>
                <div class="mb-[11px] flex items-center gap-1 text-xs text-[#555]">
                  <span>🇺🇸</span> San Francisco, USA
                </div>
                <div class="mb-[13px] flex flex-wrap gap-1.5 overflow-hidden">
                  <span
                    class="rounded-full border-[1.5px] border-[#c4dcf3] bg-[#eef6ff] px-[11px] py-1 text-[11px] font-medium text-blue-600"
                    [class.login-carousel-animate-tag]="i === currentIndex"
                    [class.login-carousel-animate-tag-1]="i === currentIndex"
                  >
                    Remote
                  </span>
                  <span
                    class="rounded-full border-[1.5px] border-[#ddd] bg-white px-[11px] py-1 text-[11px] font-medium text-[#444]"
                    [class.login-carousel-animate-tag]="i === currentIndex"
                    [class.login-carousel-animate-tag-2]="i === currentIndex"
                  >
                    Full-Time
                  </span>
                  <span
                    class="rounded-full border-[1.5px] border-[#ddd] bg-white px-[11px] py-1 text-[11px] font-medium text-[#444]"
                    [class.login-carousel-animate-tag]="i === currentIndex"
                    [class.login-carousel-animate-tag-3]="i === currentIndex"
                  >
                    Lead
                  </span>
                </div>
                <p class="text-[12px] leading-relaxed text-[#666]">
                  Design the user experience for Claude Code across various
                  platforms, including terminal and IDEs. Collaborate with
                  engineering and research teams to iterate quickly on design
                  solutions.
                </p>
              </div>
            </div>
          </div>
        </div>

        <!-- Job Alerts -->
        <div
          *ngIf="slide.visual === 'alerts'"
          class="w-full max-w-[370px]"
          [class.login-carousel-animate-slide-in]="i === currentIndex"
        >
          <div
            class="relative rounded-2xl border-[1.5px] border-[#e4e4e4] bg-white p-[1.125rem] shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
          >
            <div class="mb-3">
              <h4 class="text-sm font-bold text-[#222]">Frequency</h4>
            </div>
            <div
              class="mb-3 overflow-hidden rounded-[10px] border border-[#f0f0f0]"
            >
              <div
                class="flex items-center justify-between border-t border-[#f0f0f0] px-3 py-[9px] first:border-t-0"
              >
                <span class="text-[12.5px] text-[#333]">Daily</span>
                <div
                  class="relative h-5 w-[38px] rounded-[11px] bg-[#ddd]"
                  [class.login-carousel-animate-toggle]="i === currentIndex"
                >
                  <div
                    class="absolute left-[3px] top-[3px] h-3.5 w-3.5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.15)]"
                    [class.login-carousel-animate-toggle-knob]="i === currentIndex"
                  ></div>
                </div>
              </div>
              <div
                class="flex items-center justify-between border-t border-[#f0f0f0] px-3 py-[9px]"
              >
                <span class="text-[12.5px] text-[#333]">Every 3 days</span>
                <div class="relative h-5 w-[38px] rounded-[11px] bg-[#ddd]">
                  <div
                    class="absolute left-[3px] top-[3px] h-3.5 w-3.5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.15)]"
                  ></div>
                </div>
              </div>
              <div
                class="flex items-center justify-between border-t border-[#f0f0f0] px-3 py-[9px]"
              >
                <span class="text-[12.5px] text-[#333]">Weekly</span>
                <div class="relative h-5 w-[38px] rounded-[11px] bg-[#ddd]">
                  <div
                    class="absolute left-[3px] top-[3px] h-3.5 w-3.5 rounded-full bg-white shadow-[0_1px_3px_rgba(0,0,0,0.15)]"
                  ></div>
                </div>
              </div>
            </div>
            <div>
              <h5 class="mb-[7px] text-sm font-bold text-[#222]">Location</h5>
              <div
                class="flex items-center gap-[7px] rounded-[10px] border-[1.5px] border-[#e0e0e0] bg-white px-[11px] py-2"
                [class.login-carousel-animate-focus-ring]="i === currentIndex"
              >
                <svg
                  class="h-3.5 w-3.5 shrink-0 stroke-[#9ca3af]"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <circle cx="11" cy="11" r="8"></circle>
                  <path d="m21 21-4.35-4.35"></path>
                </svg>
                <span class="inline-flex items-center">
                  <span
                    class="text-[12.5px] font-medium text-[#111]"
                    [class.login-carousel-animate-type-in]="i === currentIndex"
                  >San Francisco, CA</span><span class="login-carousel-cursor" *ngIf="i === currentIndex"></span>
                </span>
              </div>
            </div>
            <img
              src="assets/images/homepage/email-emoji.png"
              alt=""
              class="absolute -right-2 -top-2 h-11 w-11 opacity-90 [filter:grayscale(0.4)]"
              [class.login-carousel-animate-mail]="i === currentIndex"
            />
          </div>
        </div>

        <!-- Resume Analyser -->
        <div
          *ngIf="slide.visual === 'analyser'"
          class="w-full max-w-[370px]"
          [class.login-carousel-animate-slide-in]="i === currentIndex"
        >
          <div
            class="mx-auto max-w-[300px] rounded-2xl border-[5px] border-white bg-gradient-to-b from-[#ddeaf5] from-0% via-[#e8f0f6] via-30% to-white to-[70%] p-[1.125rem] shadow-[0_4px_20px_rgba(0,0,0,0.1)]"
          >
            <div class="mb-4">
              <div
                class="mb-0.5 text-[10px] font-extrabold uppercase text-[#0d7377]"
              >
                Before you apply
              </div>
              <h4
                class="mb-1 text-[15px] font-bold leading-snug text-[#1a2b3c]"
              >
                Make sure your resume makes it through AI screening
              </h4>
              <p class="text-[11.5px] text-[#7a8a9a]">
                Scan your resume before applying
              </p>
            </div>
            <div
              class="rounded-[14px] border-[1.5px] border-[#e8e8e8] bg-white px-[18px] py-5 text-center"
              [class.login-carousel-animate-fade-up]="i === currentIndex"
              [class.login-carousel-animate-fade-up-1]="i === currentIndex"
            >
              <div class="mb-2.5 flex flex-col items-center text-[#999]">
                <hugeicons-icon
                  class="mb-0.5 block text-[#999]"
                  [icon]="icons.pdf"
                  [size]="40"
                  color="currentColor"
                  [strokeWidth]="1.5"
                ></hugeicons-icon>
              </div>
              <div class="mb-0.5 text-[13px] font-bold text-[#1a2b3c]">
                EvanSharp_Resume.pdf
              </div>
              <div class="mb-4 text-[11px] text-[#aaa]">Your resume</div>
              <button
                type="button"
                class="login-carousel-analyze-btn flex w-full items-center justify-center gap-[7px] rounded-full border-0 bg-gray-900 py-3 text-[13px] font-semibold text-white"
                [class.login-carousel-animate-btn-fill]="i === currentIndex"
              >
                <span
                  class="inline-flex items-center justify-center gap-[7px]"
                  [class.hidden]="i === currentIndex"
                >
                  <svg
                    class="h-4 w-4 shrink-0"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true"
                  >
                    <path
                      d="M12 2l2.4 7.2H22l-6 4.8 2.4 7.2L12 16.4l-6.4 4.8L8 14l-6-4.8h7.6z"
                    />
                  </svg>
                  Analyze this resume
                </span>
                <span
                  class="inline-flex items-center justify-center gap-[7px]"
                  [class.hidden]="i !== currentIndex"
                >
                  <span class="login-carousel-spinner inline-flex">
                    <hugeicons-icon
                      [icon]="icons.loading"
                      [size]="18"
                      color="currentColor"
                      [strokeWidth]="2"
                    ></hugeicons-icon>
                  </span>
                  Analysing your resume
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <div class="px-8 pb-8 pt-6 text-center text-white">
        <h3 class="mb-2 text-[1.375rem] font-bold leading-snug text-white">
          {{ slide.headline }}
        </h3>
        <p class="text-sm leading-relaxed text-white/75">
          {{ slide.subhead }}
        </p>
      </div>
    </div>
  </div>

  <button
    type="button"
    class="absolute left-4 top-1/2 z-20 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-[rgb(30_39_59/80%)] p-0 transition-all duration-200 hover:scale-105 hover:bg-[rgb(30_39_59/100%)] active:scale-95"
    (click)="previous()"
    aria-label="Previous slide"
  >
    <svg
      class="pointer-events-none h-4 w-4 stroke-white"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="15 18 9 12 15 6"></polyline>
    </svg>
  </button>

  <button
    type="button"
    class="absolute right-4 top-1/2 z-20 flex h-8 w-8 -translate-y-1/2 items-center justify-center rounded-full border-0 bg-[rgb(30_39_59/80%)] p-0 transition-all duration-200 hover:scale-105 hover:bg-[rgb(30_39_59/100%)] active:scale-95"
    (click)="next()"
    aria-label="Next slide"
  >
    <svg
      class="pointer-events-none h-4 w-4 stroke-white"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <polyline points="9 18 15 12 9 6"></polyline>
    </svg>
  </button>

  <div
    class="absolute bottom-5 left-1/2 z-10 flex -translate-x-1/2 gap-2"
  >
    <button
      *ngFor="let slide of slides; let i = index"
      type="button"
      class="cursor-pointer border-0 p-0 transition-all duration-300"
      [ngClass]="
        i === currentIndex
          ? 'h-1.5 w-5 rounded-md bg-white'
          : 'h-1.5 w-1.5 rounded-full bg-white/40 hover:bg-white/70'
      "
      (click)="goToSlide(i)"
      [attr.aria-label]="'Go to slide ' + (i + 1)"
    ></button>
  </div>
</div>
